module.exports = __webpack_public_path__ + "assets/2aeec629c7a416610f48ca96653d2270.mp3";